import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const DataProtectionNotice = (props) => {
  return (
    <div
      style={{
        padding: '2rem 8%',
        textAlign: 'left',
        minHeight: 'calc(100vh - 200px)',
        // color: "#FFFFFF",
      }}
    >
      <Typography variant={'h1'}>DATA PROTECTION NOTICE</Typography>
      <Typography variant={'h6'}>
        The controller as per the EU General Data Protection Regulation (GDPR)
        is:
      </Typography>
      <br />
      Mercedes-Benz AG („We")
      <br />
      Mercedesstraße 120, 70372 Stuttgart, Germany <br />
      E-Mail:{' '}
      <a
        href='mailto:obl-management@mercedes-benz.com'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        obl-management@mercedes-benz.com
      </a>
      <br />
      <br />
      <Typography variant={'h6'}>Data Protection Officer:</Typography>
      <br />
      Mercedes-Benz Group AG <br />
      Chief Officer Corporate Data Protection <br />
      HPC W079, 70546 Stuttgart, Germany <br />
      E-Mail:{' '}
      <a
        href='mailto:data.protection@mercedes-benz.com'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        data.protection@mercedes-benz.com
      </a>
      <br />
      <br />
      <Typography variant={'h6'}>1. Data protection</Typography>
      <br />
      We are pleased about your visit on our web pages and your interest in our
      offers. The protection of your personal data is an important concern for
      us. In these Privacy Statement we explain how we collect your personal
      data, what we do with it, for what purposes and on what legal basis this
      is done, and which rights and claims are associated with it for you. In
      addition, we refer to the Mercedes-Benz Data Protection Policy:
      Mercedes-Benz Data Protection Policy. <br /> <br />
      Our Privacy Statement for the use of our websites and the Data Protection
      Policy of Mercedes-Benz Group AG do not apply to your activities on the
      websites of social networks or other providers that you can reach via the
      links on our websites. Please check the websites of these providers for
      their data protection regulations. <br /> <br />
      <Typography variant={'h6'}>
        2. Collection and processing of your personal data
      </Typography>
      <br />
      a. When you visit our website, we store certain information about the
      browser and operating system you use, the date and time of your visit, the
      access status (e.g. whether you were able to access a website or received
      an error message), the use of website functions, the search terms you may
      have entered, the frequency with which you access individual websites, the
      designation of files accessed, the amount of data transferred, the website
      from which you accessed our websites and the website which you visit from
      our websites, either by clicking on links on our websites or by entering a
      do-main directly in the input field of the same tab (or the same window)
      of your browser in which you opened our websites. We also store your IP
      ad-dress and the name of your Internet service provider for seven days for
      security reasons, in particular to prevent and detect attacks on our
      websites or attempts at fraud.
      <br />
      <br />
      b. We only store other personal data if you provide this data, e.g. as
      part of a registration, a contact form, a survey, a price competition or
      for the execution of a contract, and even in these cases only insofar as
      this is permitted to us on the basis of a consent given by you or in
      accordance with the applicable legal provisions (further information on
      this can be found below in the section "Legal bases of processing").
      <br />
      <br />
      c. You are not legally or contractually obliged to make available your
      personal data. However, it is possible that certain functions of our
      websites depend on the availability of personal data. If you do not make
      available personal data in these cases, this may result in functions not
      being available or only being available to a limited extent. <br />
      <br />
      <Typography variant={'h6'}>3. Purposes of use </Typography>
      <br />
      a. We use the personal data collected when you visit our website in order
      to operate it in the most convenient manner for your use and to protect
      our IT systems from attacks and other illegal activities. <br />
      <br />
      b. If you provide us with further personal data, e.g. within the scope of
      a registration, a contact form, a survey, a price competition or for the
      execution of a contract, we use this data for the purposes mentioned, for
      the purposes of customer administration and - if necessary - for the
      purposes of processing and accounting of any business transactions, in
      each case to the extent required for this. <br />
      <br />
      <Typography variant={'h6'}>
        4. Transfer of personal data to third parties; social plug-ins; use of
        service providers
      </Typography>
      <br />
      a. Our websites may also contain an offer of third parties. If you click
      on such an offer, we transfer data to the respective provider to the
      required extent (e.g. information that you have found this offer with us
      and, if applicable, further information that you have already provided on
      our websites for this purpose). <br />
      <br />
      b. When we use social plug-ins on our websites from social networks, we
      integrate them as follows: <br />
      <br />
      When you visit our websites, the social plug-ins are deactivated, i.e. no
      data is transmitted to the operators of these networks. If you want to use
      one of the networks, click on the respective social plug-in to establish a
      direct connection to the server of the respective network. <br />
      <br />
      If you have a user account on the network and are logged in when you
      activate the social plug-in, the network can associate your visit to our
      websites with your user account. If you want to avoid this, please log out
      of the network before activating the social plug-in. A social network
      cannot associate a visit to other Mercedes-Benz websites until you have
      activated an existing social plug-in.
      <br />
      <br /> When you activate a social plug-in, the network transfers the
      content that becomes available directly to your browser, which integrates
      it into our websites. In this situation, data transmissions can also take
      place that are initiated and controlled by the respective social network.
      Your connection to a social network, the data transfers taking place
      between the network and your system, and your interactions on that
      platform are governed sole-ly by the privacy policies of that network.
      <br />
      <br /> The social plug-in remains active until you deactivate it or delete
      your{' '}
      <Link
        to='/cookiesuse'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        Cookies
      </Link>
      . <br />
      <br />
      c. If you click on the link to an offer or activate a social plug-in,
      personal data may reach providers in countries outside the European
      Economic Area that, from the point of view of the European Union ("EU"),
      may not guarantee an "adequate level of protection" for the processing of
      personal data in accordance with EU standards. Please remember this fact
      before clicking on a link or activating a social plug-in and thereby
      triggering a transfer of your data.
      <br />
      <br />
      d. We also use qualified service providers (IT service providers,
      marketing agencies) to operate, optimize and secure our websites. We only
      pass on personal data to third parties if and to the extent necessary for
      the provision and use of the websites and their functionalities, for the
      pursuit of legitimate interests or if you have consented to it (see
      section "Legal bases of processing" below). <br />
      <br />
      <Typography variant={'h6'}>5. Security</Typography>
      <br />
      We use technical and organisational security measures to protect your data
      managed by us against manipulation, loss, destruction and against access
      by unauthorised persons. We are constantly improving our security measures
      in line with technological developments. <br />
      <br />
      <Typography variant={'h6'}>6. Legal bases of processing </Typography>
      <br />
      a. Insofar as you have given us your consent for the processing of your
      personal data, that consent is the legal basis for the processing (Art. 6
      para. 1 letter a GDPR). <br />
      <br />
      b. For the processing of personal data for the purposes of initiating or
      fulfilling a contract with you, Art. 6 para. 1 letter b GDPR is the legal
      basis. <br />
      <br />
      c. Insofar as the processing of your personal data is necessary for the
      fulfilment of our legal obligations (e.g. for the retention of data), we
      are authorized to do so pursuant to Art. 6 para. 1 letter c GDPR.
      <br />
      <br />
      d. In addition, we process personal data for the purposes of safeguarding
      our legitimate interests and the legitimate interests of third parties
      pursuant to Art. 6 para. 1 letter f GDPR. Maintaining the functionality of
      our IT systems, (direct-) marketing our own and third-party products and
      services as well as documenting business contacts as required by law are
      such legitimate interests. As part of the consideration of interests
      required in each case, we take into account various aspects, in particular
      the type of personal information, the purpose of processing, the
      circumstances of processing and your interest in the confidentiality of
      your personal information. <br />
      <br />
      <Typography variant={'h6'}>7. Deletion of your personal data</Typography>
      <br />
      Your IP address and the name of your Internet service provider, which we
      only store for security reasons, will be deleted after seven days.
      Otherwise, we delete your personal data as soon as the purpose for which
      we have collected and processed the data ceases to apply. Beyond this time
      period, data storage only takes place to the extent made necessary by the
      legislation, regulations or other legal provisions to which we are subject
      in the EU or by legal provisions in third-party countries if these have an
      appropriate level of data protection. Should it not be possible to delete
      data in individual cases, the relevant personal data are flagged to
      restrict their further processing. <br />
      <br />
      <Typography variant={'h6'}>8. Rights of the data subject</Typography>
      <br />
      a. As a data subject, you have the right of access (Art. 15 GDPR), right
      to rectification (Art. 16 GDPR), right to erasure (Art. 17 GDPR), right to
      restriction of processing (Art. 18 GDPR) and right to data portability
      (Art. 20 GDPR). <br />
      <br />
      b. If you have consented to the processing of your personal data by us,
      you have the right to revoke your consent at any time. The legality of
      processing your personal data before revocation remains unaffected. We may
      further process such data pursuant to another applicable legal basis, e.g.
      for the fulfilment of our legal obligations (see section "Legal bases of
      processing"). <br />
      <br />
      c. Right to object <br />
      You have the right to object at any time to the processing of your
      personal data pursuant to Art. 6 para. 1 letter e GDPR (data processing in
      the public interest) or Art. 6 para. 1 letter f GDPR (data processing on
      the basis of a balance of interests) on grounds relating to your
      particular situation. If you object, we will only process your personal
      data if we can prove compelling legitimate reasons that outweigh your
      interests, rights and freedoms, or for the establishment, exercise or
      defense of legal claims. To the extent we process your personal data for
      direct marketing purposes, you have the right to object thereto at any
      time without giving reasons. <br />
      <br />
      d. We ask you to address your claims or declarations to the following
      contact address if possible:{' '}
      <a
        href='mailto:obl-management@mercedes-benz.com'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        obl-management@mercedes-benz.com
      </a>
      .
      <br />
      <br />
      e. If you believe that the processing of your personal data violates legal
      requirements, you have the right to lodge a complaint with a competent
      data protection supervisory authority (Art. 77 GDPR). <br />
      <br />
      <Typography variant={'h6'}>9. Newsletter</Typography>
      <br />
      If you subscribe to a newsletter offered on our website, the data provided
      in the newsletter subscription will only be used for sending the
      newsletter, unless you agree to further use. You can unsubscribe at any
      time using the unsubscribe option provided in the newsletter. <br />
      <br />
      <Typography variant={'h6'}>
        10. Central Access Service of Mercedes-Benz Group AG
      </Typography>
      <br />
      With the Central Registration Service offered by Mercedes-Benz Group AG,
      you can sign up for every website and application belonging to the
      Mercedes-Benz Group and its brands that are connected to the service. The
      applicable terms of use contain specific data protection provisions. Those
      terms of use can be found on the registration pages of affiliated websites
      and applications. <br />
      <br />
      <Typography variant={'h6'}>
        11. Data transmission to recipients outside the European Economic Area
      </Typography>
      <br />
      a. When using service providers (see section "Use of service providers"),
      personal data may be transferred and processed by recipients in countries
      outside the European Union ("EU"), Iceland, Liechtenstein and Norway (=
      European Economic Area), in particular the USA, India.
      <br />
      b. From the point of view of the EU, the following countries provide an
      adequate level of protection for the processing of personal data in
      accordance with EU standards (so-called adequacy decision): Andorra,
      Argentina, Canada (limited), Faroe Islands, Guernsey, Israel, Isle of Man,
      Japan, Jersey, New Zealand, South-Korea, Switzerland, United Kingdom,
      United States of America (limited), Uruguay. We agree with recipients in
      other countries to apply EU standard contractual clauses, binding company
      regulations or other applicable instruments (if any) in order to create an
      appropriate level of protection in accordance with the legal requirements.
      For more information, please use the contact details given in the section
      "Rights of the data subject" above. <br />
      <br />
      <Typography variant={'h6'}>12. Cookies</Typography>
      <br />
      Information on the cookies we use and their functions can be found in our{' '}
      <Link
        to='/cookiesuse'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        Cookie Statement
      </Link>
      .<br />
      <br />
      E-Mail:{' '}
      <a
        href='mailto:obl-management@mercedes-benz.com'
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        obl-management@mercedes-benz.com
      </a>
    </div>
  );
};

export { DataProtectionNotice };
